module.exports = __webpack_public_path__ + "img/CardImage13.a34fb4f2.png";